import { MENU_FULFILLMENT_TYPES } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
const getDefaultMax = () => 1;
export default new BaseMenuEntityConfiguration({
    consumable: true,
    filters: [
        {
            name: 'fulfillmentType',
            options: MENU_FULFILLMENT_TYPES,
            type: 'Select',
        },
        {
            name: 'topping',
            type: 'Boolean',
        },
    ],
    hasDescription: true,
    hasHours: false,
    hasImage: true,
    hasVariations: true,
    hasPos: true,
    hasPresentation: true,
    lists: [
        {
            collection: 'ModifierSet',
            name: 'modifierSets',
            primaryRelationship: true,
        },
    ],
    name: 'Modifier',
    options: {
        allowOnSide: false,
        topping: false,
        min: 0,
        // Legacy documents store null; consumers coalesce it to 1.
        max: getDefaultMax(),
    },
    pluralizedName: 'Modifiers',
    sellable: true,
    sortKeys: [],
    unlinkedOptions: [],
    version: 13,
});
//# sourceMappingURL=modifier.js.map